export enum PolygonDirection {
    UP = 'up',
    DOWN = 'down',
}
